import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
@Injectable({
  providedIn: 'root'
})
export class GetMaskingService {

  constructor(public httpClient: HttpClient, public wpTokenService: WpTokenService) {}

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if(this.VERIFY_TOKEN_EXPIRE){
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: any) {
    return param;
  }

  output(result: any) {
    return result;
  }

  connector(param: any) {
    const url = `${environment.endpointBackend}/api/query/getMasking`;
    const body = this.input(param);
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // Core Function ! No modify
  exec(param: any) {
    const self = this;
    return new Promise(function(resolve, reject) {
      if(!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()){
        self.connector(param).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            resolve(self.output(res['body']));
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus:  401,
          message: 'token is expired'
        });
      }
    });
  }
  maskingData(data:string){
    let datamasking = "";
    if(data !== null && data !== undefined){
        let countdata = data.length
    
        if(countdata>4){
            datamasking += `xxxxx${data.substring(countdata-4)}`;
        }else if(countdata == 0){
            datamasking = "";
        }else{
            datamasking += `xxxxx${data}xxxx`;
        }
    }
    
    return datamasking;
}
  maskingDataObj = (data, index = 0) => {
    try {
      if (index >= 10) return "Maximum limit exceeded";
  
      if (Array.isArray(data) && data.length > 0) {
        return data.map((v) => this.maskingDataObj(v, index + 1));
      } else if (data && typeof data === 'object') {
        const maskedObject = {};
        for (const [key, value] of Object.entries(data)) {
          maskedObject[key] = this.maskingDataObj(value, index + 1);
        }
        return maskedObject;
      } else {
        return this.maskingFn(data);
      }
    } catch (err) {
      return `maskingData error: ${err.message}`;
    }
  };
  
  maskingFn = (data) => {
    if (!data) {
      return data;
    } else if (typeof data === 'number' && data.toString().length <= 1) {
      return data;
    }
  
    const text = data.toString();
    const count = text.length;
  
    if (count === 0) {
      return "";
    } else if (count > 4) {
      return `xxxxx${text.substring(count - 4)}`;
    } else {
      return `xxxxx${text}xxxx`;
    }
  }
}
